
import VisitRapport from '../../../startpage/(pages)/visit-rapport/page';

const VisitInterventionRapport = () => {
  return (<VisitRapport previousPage='intervention' />)
}

export default VisitInterventionRapport